import { ApartmentSizes, ApartmentType, ContractType, CustomerType, InvoiceType, Order, Phase, Preference } from './types.ts';

import iconRivitalo from '../../../assets/images/icon-rivitalo.svg';
import iconKerrostalo from '../../../assets/images/icon-kerrostalo.svg';
import iconMokki from '../../../assets/images/icon-mokki.svg';
import iconOmakotitalo from '../../../assets/images/icon-omakotitalo.svg';
import iconAreaS from '../../../assets/images/icon-area-S.svg';
import iconAreaM from '../../../assets/images/icon-area-M.svg';
import iconAreaL from '../../../assets/images/icon-area-L.svg';
import iconAreaXL from '../../../assets/images/icon-area-XL.svg';
import iconEco from '../../../assets/images/icon-eco.svg';
import iconPorssi from '../../../assets/images/icon-porssi.svg';
import iconHinta from '../../../assets/images/icon-hinta.svg';
import iconKiintea from '../../../assets/images/icon-kiintea.svg';

export const apartmentTypes: ApartmentType[] = [
  { label: 'apartmentType.blockOfFlats', value: 'kerrostalo', img: iconKerrostalo, imgAlt: 'kerrostalo' },
  { label: 'apartmentType.rowHouse', value: 'rivitalo', img: iconRivitalo, imgAlt: 'rivitalo' },
  { label: 'apartmentType.detachedHouse', value: 'omakotitalo', img: iconOmakotitalo, imgAlt: 'omakotitalo' },
  { label: 'apartmentType.cottage', value: 'mokki', img: iconMokki, imgAlt: 'kerrostalo' },
]

export const apartmentSizes: ApartmentSizes = {
  'kerrostalo': [
    { size: "30", label: 'apartmentSizes.below', value: '30', img: iconAreaS },
    { size: "30-44", label: 'apartmentSizes.between', value: '37', img: iconAreaM },
    { size: "45-60", label: 'apartmentSizes.between', value: '52', img: iconAreaL },
    { size: "60", label: 'apartmentSizes.above', value: '60', img: iconAreaXL }
  ],
  'rivitalo': [
    { size: "60", label: 'apartmentSizes.below', value: '60', img: iconAreaS },
    { size: "60-89", label: 'apartmentSizes.between', value: '75', img: iconAreaM },
    { size: "90-120", label: 'apartmentSizes.between', value: '105', img: iconAreaL },
    { size: "120", label: 'apartmentSizes.above', value: '120', img: iconAreaXL }
  ],
  'omakotitalo': [
    { size: "90", label: 'apartmentSizes.below', value: '90', img: iconAreaS },
    { size: "90-109", label: 'apartmentSizes.between', value: '100', img: iconAreaM },
    { size: "110-139", label: 'apartmentSizes.between', value: '125', img: iconAreaL },
    { size: "140", label: 'apartmentSizes.above', value: '140', img: iconAreaXL }
  ],
  'mokki': [
    { size: "30", label: 'apartmentSizes.below', value: '30', img: iconAreaS },
    { size: "30-44", label: 'apartmentSizes.netweem', value: '37', img: iconAreaM },
    { size: "45-60", label: 'apartmentSizes.between', value: '52', img: iconAreaL },
    { size: "60", label: 'apartmentSizes.above', value: '60', img: iconAreaXL }
  ],
}

export const preferences: Preference[] = [
  { label: 'preferences.ecological', value: 'Ekologinen', img: iconEco },
  { label: 'preferences.stockPrice', value: 'Pörssihintainen', img: iconPorssi },
  { label: 'preferences.fixedPrice', value: 'Kiinteä', img: iconKiintea },
  { label: 'preferences.affordable', value: 'Edullinen', img: iconHinta },
]

export const b2bPreferences: Preference[] = preferences.filter(preference => preference.value !== 'Ekologinen')

export const invoiceTypes: InvoiceType[] = [
  { label: "invoiceTypes.einvoice", value: 'einvoice' },
  { label: "invoiceTypes.paper", value: 'paper' },
  { label: "invoiceTypes.email", value: 'email' },
  { label: "invoiceTypes.kivra", value: 'kivra' },
]

export const b2bInvoiceTypes: InvoiceType[] = [
  { label: "invoiceTypes.b2beInvoice", value: 'b2b-einvoice' },
  { label: "invoiceTypes.paper", value: 'paper' },
  { label: "invoiceTypes.email", value: 'email' },
]

export const einvoiceBanks: string[] = ['Aktia Pankki', 'Danske Bank', 'Handelsbanken', 'Nordea', 'Osuuspankki', 'POP Pankki', 'S-pankki', 'Säästöpankki', 'Ålandsbanken']

export const contractTypes: ContractType[] = [
  { label: "contractTypes.move", value: 'MoveIn', description: "contractTypes.moveDesc" },
  { label: "contractTypes.new", value: 'New', description: "contractTypes.newDesc" },
  { label: "contractTypes.change", value: 'ProductChange', description: "contractTypes.changeDesc" },
]

export const customerTypes: CustomerType[] = [
  { label: 'customerType.consumers', value: 'kuluttajat', img: iconRivitalo, imgAlt: 'rivitalo' },
  { label: 'customerType.companies', value: 'yritykset', img: iconKerrostalo, imgAlt: 'kerrostalo' },
]

export const b2cPhases: Phase[] = [
  { label: 'phases.target', value: 'kohde', key: 1, showNextButton: true },
  { label: 'phases.contract', value: 'sopimus', key: 2 },
  { label: 'phases.services', value: 'palvelut', key: 3, showNextButton: true },
  { label: 'phases.summary', value: 'yhteenveto', key: 4, showConfirmButton: true },
  { label: 'phases.loading', value: 'loading', key: 6, hideLabel: true },
  { label: 'phases.error', value: 'error', key: 7, hideLabel: true },
]

// Add Asiakastiedot with key 4 and move Yhteenveto to key 5, Loading to key 6 and Error to key 7
export const b2bPhases: Phase[] = [
  { label: 'phases.target', value: 'kohde', key: 1, showNextButton: false },
  { label: 'phases.contract', value: 'sopimus', key: 2 },
  { label: 'phases.services', value: 'palvelut', key: 3, showNextButton: false },
  { label: 'phases.customerInfo', value: 'asiakastiedot', key: 4, showNextButton: true },
  { label: 'phases.summary', value: 'yhteenveto', key: 5, showConfirmButton: true },
  { label: 'phases.loading', value: 'loading', key: 6, hideLabel: true },
  { label: 'phases.error', value: 'error', key: 7, hideLabel: true },
]

export const emptyOrder: Order = {
  'channel-code': '',
  'business-type': undefined,
  'customer-type': '',
  'apartment-type': '',
  'apartment-size': '',
  'preferences': '',
  'electric-sauna': '',
  'electric-heating': '',
  'consumption-estimate': '',
  'product': '',
  'additional-services': '',
  'email': '',
  'phone': '',
  'accept-terms': '',
  'accept-email-marketing': '',
  'accept-sms-marketing': '',
  'contract-type': '',
  'contract-startdate': '',
  'invoice-method': '',
  'location-street': '',
  'location-house': '',
  'location-postalcode': '',
  'location-city': '',
  'location-stairway': '',
  'location-flat': '',
  'separated-invoicing-address': '',
  'invoice-street': '',
  'invoice-house': '',
  'invoice-postalcode': '',
  'invoice-city': '',
  'invoice-stairway': '',
  'invoice-flat': '',
  'einvoice-bank': '',
  'b2b-address': '',
  'b2b-operator': '',
  'b2b-email': '',
  'company-name': '',
  'organization-no': '',
  'invoice-careof': '',
  'location-careof': '',
  'contact-firstname': '',
  'contact-lastname': '',
  'contact-email': '',
  'contact-phone': '',
  'metering-points': [],
  'language': 'fi',
}

export const filledb2bOrder: Order = {
  "customer-type": "yritykset",
  "business-type": "small",
  "apartment-type": "",
  "apartment-size": "",
  "preferences": "Kiinteä",
  "consumption-estimate": "260000",
  "product": "276",
  "additional-services": "189",
  "email": "",
  "phone": "",
  "accept-terms": "",
  "accept-email-marketing": "",
  "accept-sms-marketing": "",
  "contract-type": "New",
  "contract-startdate": "15.05.2025",
  "invoice-method": "b2b-einvoice",
  "invoice-street": "",
  "invoice-house": "",
  "invoice-postalcode": "",
  "invoice-city": "",
  "invoice-stairway": "",
  "invoice-flat": "",
  "separated-invoicing-address": "",
  "location-street": "Linnankatu",
  "location-house": "55",
  "location-postalcode": "20100",
  "location-city": "Turku",
  "location-stairway": "I",
  "location-flat": "301",
  "einvoice-bank": "",
  "b2b-address": "FI49 5000 9420 0287 30", // valid IBAN: FI49 5000 9420 0287 30 and valid OVT: 003718540478
  "b2b-operator": "NDEAFIHH",
  'b2b-email': '',
  "company-name": "Yritys AB",
  "organization-no": "1234567-1",
  "invoice-careof": "tarkka",
  "location-careof": "",
  "contact-firstname": "Testi",
  "contact-lastname": "Henkilö",
  "contact-email": "test@test.com",
  "contact-phone": "1234567890",
  "metering-points": [
    {
      "startDate": "28.04.2025",
      "address": {
        "streetName": "Linnankatu",
        "houseNumber": "55",
        "houseLetter": "I",
        "residence": "301",
        "zipCode": "20100",
        "cityName": "Turku",
      }
    },
    {
      "startDate": "30.05.2025",
      "address": {
        "streetName": "Ulvilantie",
        "houseNumber": "2",
        "zipCode": "00350",
        "cityName": "HELSINKI",
        "houseLetter": "B",
        "residence": "2",
      },
      "diffStart": true
    }
  ],
  "electric-heating": undefined,
  "electric-sauna": undefined,
  "channel-code": "",
  "language": "fi",
}

export const filledb2cOrder: Order = {
  "customer-type": "kuluttajat",
  "apartment-type": "omakotitalo",
  "apartment-size": "140",
  "preferences": "Edullinen",
  "electric-heating": "on",
  "consumption-estimate": "15652",
  "product": "3",
  "additional-services": "326",
  "email": "joo@joo.fi",
  "phone": "1234567890",
  "accept-terms": "on",
  "accept-email-marketing": "",
  "accept-sms-marketing": "",
  "contract-type": "New",
  "contract-startdate": "15.05.2025",
  "invoice-method": "einvoice",
  "location-street": "Linnankatu",
  "location-house": "55",
  "location-postalcode": "20100",
  "location-city": "Turku",
  "location-stairway": "",
  "location-flat": "",
  "separated-invoicing-address": "on",
  "invoice-street": "ulvilantie",
  "invoice-house": "21",
  "invoice-postalcode": "00350",
  "invoice-city": "HELSINKI",
  "invoice-stairway": "B",
  "invoice-flat": "2",
  "einvoice-bank": "Nordea",
  "b2b-address": "",
  "b2b-operator": "",
  'b2b-email': "",
  "company-name": "",
  "organization-no": "",
  "invoice-careof": "",
  "location-careof": "",
  "contact-firstname": "",
  "contact-lastname": "",
  "contact-email": "",
  "contact-phone": "",
  "metering-points": [],
  "electric-sauna": undefined,
  "channel-code": "",
  "language": "fi",
}

export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const phoneRegex = /^(\+|[0-9])[0-9]{7,13}$/;
export const addressRegex = /^[a-zA-Z0-9.\-\/]*$/;

export const dateInputFormat = 'DD.MM.YYYY';
export const dateOutPutFormat = 'YYYY-MM-DD';
